(function () {
  var mainSliderInstance = null;
  var thumbDesktopInstance = null;
  var thumbMobileInstance = null;
  var galleryLoadToken = 0;
  var pendingUserVariantChange = false;
  var lastGalleryVisualKey = '';
  var watchHintTimer = null;
  var watchHintShowOnScroll = null;
  var watchHintArmed = false;
  var watchHintPositionOnScroll = null;
  var watchHintHideOnScrollTimer = null;
  var watchHintIgnoreScrollUntil = 0;
  var watchHintUserScrolled = false;
  var watchHintUserScrollBound = false;
  var watchHintOnResize = null;

  var DESKTOP_THUMB_PER_VIEW = 4;
  var DESKTOP_THUMB_SPACING = 20;
  var DESKTOP_THUMB_HEIGHT = 101;

  function getGalleryRoot() {
    return document.querySelector('.product-gallery[data-product-gallery]');
  }

  function getMainSliderEl() {
    return document.querySelector('#main-slider');
  }

  function getCrossfadeLayer() {
    return document.querySelector('.product-gallery__crossfade');
  }

  function getVisibleMainImage() {
    var slider = getMainSliderEl();
    if (!slider) return null;
    var slides = slider.querySelectorAll('.keen-slider__slide .main-image');
    var idx = 0;
    if (mainSliderInstance && mainSliderInstance.track && mainSliderInstance.track.details) {
      idx = mainSliderInstance.track.details.rel || 0;
    }
    return slides[idx] || slides[0] || null;
  }

  function syncCrossfadeBox(layer) {
    var slider = getMainSliderEl();
    var stage = document.querySelector('.product-gallery__stage');
    if (!slider || !stage || !layer) return;
    layer.style.top = slider.offsetTop + 'px';
    layer.style.left = slider.offsetLeft + 'px';
    layer.style.width = slider.offsetWidth + 'px';
    layer.style.height = slider.offsetHeight + 'px';
  }

  function captureOutgoingImage() {
    var layer = getCrossfadeLayer();
    if (!layer) return false;

    if (layer.classList.contains('is-on') && !layer.classList.contains('is-out')) {
      galleryLoadToken += 1;
      return true;
    }

    var current = getVisibleMainImage();
    if (!current || !(current.currentSrc || current.src)) return false;

    var img = layer.querySelector('img');
    if (!img) return false;
    img.src = current.currentSrc || current.src;
    syncCrossfadeBox(layer);
    layer.classList.remove('is-out');
    layer.classList.add('is-on');
    galleryLoadToken += 1;
    return true;
  }

  function startVariantLoading() {
    var captured = captureOutgoingImage();
    if (captured) getGalleryRoot()?.classList.add('is-variant-loading');
  }

  function normalizeVisualKey(value) {
    return String(value || '').split('?')[0];
  }

  function getWatchHintButton() {
    return document.querySelector('[data-watch-scroll-hint]');
  }

  function getWatchHintTopOffset() {
    var top = 12;
    document.querySelectorAll(
      'sticky-header, .header-wrapper, header, .announcement-bar, .utility-bar, [id*="announcement"]'
    ).forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.height > 8 && rect.top < 120 && rect.bottom > top) {
        top = Math.round(rect.bottom + 10);
      }
    });
    return top;
  }

  function isGalleryOutOfFocus() {
    var gallery = getGalleryRoot();
    if (!gallery) return false;
    var header = document.querySelector('sticky-header, .header-wrapper, header');
    var headerBottom = header ? header.getBoundingClientRect().bottom : 72;
    var rect = gallery.getBoundingClientRect();
    return rect.top < headerBottom + 8 || rect.bottom < window.innerHeight * 0.72;
  }

  function applyWatchHintPosition() {
    var hint = getWatchHintButton();
    if (!hint) return;
    hint.style.bottom = 'auto';
    hint.style.top = getWatchHintTopOffset() + 'px';
  }

  function clearWatchHintScrollArm() {
    watchHintArmed = false;
    if (watchHintShowOnScroll) {
      window.removeEventListener('scroll', watchHintShowOnScroll);
      watchHintShowOnScroll = null;
    }
  }

  function markWatchHintUserScroll() {
    watchHintUserScrolled = true;
  }

  function bindWatchHintUserScroll() {
    if (watchHintUserScrollBound) return;
    watchHintUserScrollBound = true;
    window.addEventListener('wheel', markWatchHintUserScroll, { passive: true });
    window.addEventListener('touchmove', markWatchHintUserScroll, { passive: true });
    window.addEventListener('keydown', markWatchHintUserScroll);
  }

  function unbindWatchHintUserScroll() {
    if (!watchHintUserScrollBound) return;
    watchHintUserScrollBound = false;
    window.removeEventListener('wheel', markWatchHintUserScroll);
    window.removeEventListener('touchmove', markWatchHintUserScroll);
    window.removeEventListener('keydown', markWatchHintUserScroll);
  }

  function stopWatchHintPositionSync() {
    if (watchHintPositionOnScroll) {
      window.removeEventListener('scroll', watchHintPositionOnScroll);
      watchHintPositionOnScroll = null;
    }
    if (watchHintOnResize) {
      window.removeEventListener('resize', watchHintOnResize);
      watchHintOnResize = null;
    }
    unbindWatchHintUserScroll();
  }

  function startWatchHintPositionSync() {
    stopWatchHintPositionSync();
    bindWatchHintUserScroll();
    watchHintOnResize = applyWatchHintPosition;
    watchHintPositionOnScroll = function () {
      applyWatchHintPosition();
      if (Date.now() < watchHintIgnoreScrollUntil) return;
      if (!watchHintUserScrolled) return;
      if (watchHintHideOnScrollTimer) return;
      watchHintHideOnScrollTimer = window.setTimeout(hideWatchHint, 500);
    };
    window.addEventListener('scroll', watchHintPositionOnScroll, { passive: true });
    window.addEventListener('resize', watchHintOnResize);
  }

  function hideWatchHint() {
    var hint = getWatchHintButton();
    if (hint) {
      hint.classList.remove('is-visible');
      hint.setAttribute('aria-hidden', 'true');
      hint.setAttribute('tabindex', '-1');
    }
    if (watchHintTimer) {
      window.clearTimeout(watchHintTimer);
      watchHintTimer = null;
    }
    if (watchHintHideOnScrollTimer) {
      window.clearTimeout(watchHintHideOnScrollTimer);
      watchHintHideOnScrollTimer = null;
    }
    clearWatchHintScrollArm();
    stopWatchHintPositionSync();
  }

  function showWatchHint(options) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var hint = getWatchHintButton();
    if (!hint) return;

    clearWatchHintScrollArm();
    if (watchHintHideOnScrollTimer) {
      window.clearTimeout(watchHintHideOnScrollTimer);
      watchHintHideOnScrollTimer = null;
    }
    applyWatchHintPosition();
    hint.classList.add('is-visible');
    hint.setAttribute('aria-hidden', 'false');
    hint.removeAttribute('tabindex');
    watchHintUserScrolled = false;
    watchHintIgnoreScrollUntil = Date.now() + ((options && options.ignoreScrollMs) || 400);
    startWatchHintPositionSync();

    if (watchHintTimer) window.clearTimeout(watchHintTimer);
    watchHintTimer = window.setTimeout(hideWatchHint, 5000);
  }

  function armWatchHintOnScroll() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    if (!getWatchHintButton()) return;

    clearWatchHintScrollArm();
    watchHintArmed = true;
    watchHintShowOnScroll = function () {
      if (!watchHintArmed || !isGalleryOutOfFocus()) return;
      showWatchHint();
    };
    window.addEventListener('scroll', watchHintShowOnScroll, { passive: true });
    window.setTimeout(function () {
      if (watchHintArmed && isGalleryOutOfFocus()) showWatchHint();
    }, 5000);
  }

  function maybeShowWatchHint(images) {
    var nextKey = images && images[0] ? normalizeVisualKey(images[0]) : '';
    var visualChanged = Boolean(nextKey && lastGalleryVisualKey && nextKey !== lastGalleryVisualKey);
    if (nextKey) lastGalleryVisualKey = nextKey;

    if (!pendingUserVariantChange) return;
    pendingUserVariantChange = false;

    if (!visualChanged) {
      hideWatchHint();
      return;
    }

    if (isGalleryOutOfFocus()) {
      showWatchHint();
      return;
    }

    armWatchHintOnScroll();
  }

  function maybeShowWatchHintAfterVersionLanding() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    if (!getWatchHintButton()) return;

    var fromVersionHash = window.location.hash === '#version';
    var fromVersionClick = false;
    try {
      fromVersionClick = sessionStorage.getItem('cmWatchHint') === '1';
      if (fromVersionClick) sessionStorage.removeItem('cmWatchHint');
    } catch (err) {
      fromVersionClick = false;
    }

    if (!fromVersionHash && !fromVersionClick) return;

    var versionBlock = document.getElementById('version');
    if (versionBlock) {
      versionBlock.scrollIntoView({ block: 'start' });
    }

    var tryShow = function () {
      showWatchHint({ ignoreScrollMs: 2000 });
      return true;
    };

    window.setTimeout(tryShow, 80);
    window.setTimeout(tryShow, 350);
  }

  function setupWatchHint() {
    var hint = getWatchHintButton();
    if (!hint || hint.dataset.watchHintBound === 'true') return;
    hint.dataset.watchHintBound = 'true';

    hint.addEventListener('click', function () {
      hideWatchHint();
      var gallery = getGalleryRoot();
      if (!gallery) return;
      gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    document.querySelectorAll('a.version-pills-grid__card').forEach(function (link) {
      link.addEventListener('click', function () {
        try {
          sessionStorage.setItem('cmWatchHint', '1');
        } catch (err) {
          /* ignore */
        }
      });
    });
  }

  function finishGalleryLoading(image) {
    var root = getGalleryRoot();
    var layer = getCrossfadeLayer();
    var token = galleryLoadToken;

    var reveal = function () {
      if (token !== galleryLoadToken) return;
      if (layer && layer.classList.contains('is-on')) {
        layer.classList.add('is-out');
        window.setTimeout(function () {
          if (token !== galleryLoadToken) return;
          layer.classList.remove('is-on', 'is-out');
          var overlayImg = layer.querySelector('img');
          if (overlayImg) overlayImg.removeAttribute('src');
        }, 800);
      }
      if (root) root.classList.remove('is-variant-loading');
    };

    if (!root || !root.classList.contains('is-variant-loading')) {
      return;
    }

    var run = function () {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(reveal);
      });
    };

    if (!image || (image.complete && image.naturalWidth > 0)) {
      run();
      return;
    }

    image.addEventListener('load', run, { once: true });
    image.addEventListener('error', run, { once: true });
    window.setTimeout(run, 4000);
  }

  function destroySliders() {
    if (mainSliderInstance) {
      mainSliderInstance.destroy();
      mainSliderInstance = null;
    }
    if (thumbDesktopInstance) {
      thumbDesktopInstance.destroy();
      thumbDesktopInstance = null;
    }
    if (thumbMobileInstance) {
      thumbMobileInstance.destroy();
      thumbMobileInstance = null;
    }

    var nav = document.querySelector('[data-product-gallery-nav]');
    if (nav) delete nav.dataset.galleryNavBound;
  }

  function buildMainSlideHtml(imageUrl, isFirst) {
    var loading = isFirst ? 'eager' : 'lazy';
    var fetchAttr = isFirst ? ' fetchpriority="high"' : '';
    var retinaUrl = imageUrl.replace('width=594', 'width=1188').replace('_594x', '_1188x');
    return (
      '<img width="594" height="733" loading="' +
      loading +
      '"' +
      fetchAttr +
      ' src="' +
      imageUrl +
      '" alt="" class="main-image tw-size-full tw-object-contain !tw-max-w-full lg:!tw-h-[733px] !tw-h-fit md:!tw-h-[594px] lg:!tw-max-w-[594px] tw-cursor-pointer" data-large-src="' +
      imageUrl +
      '" onclick="openPopup(this)" srcset="' +
      imageUrl +
      ' 1x, ' +
      retinaUrl +
      ' 2x" sizes="(max-width: 768px) 100vw, (min-width: 769px) 594px" />'
    );
  }

  function buildThumbnailHtml(imageUrl, index, variant) {
    var variantClass = variant === 'desktop' ? 'image-thumbnail--desktop' : 'image-thumbnail--mobile';
    var width = variant === 'desktop' ? 72 : 72;
    var height = variant === 'desktop' ? 101 : 93;
    return (
      '<button type="button" class="image-thumbnail ' +
      variantClass +
      (index === 0 ? ' active' : '') +
      '" data-index="' +
      index +
      '" aria-label="Product image ' +
      (index + 1) +
      '" aria-current="' +
      (index === 0 ? 'true' : 'false') +
      '">' +
      '<img class="image-thumbnail__img" loading="lazy" src="' +
      imageUrl +
      '" alt="" width="' +
      width +
      '" height="' +
      height +
      '" />' +
      '</button>'
    );
  }

  function buildThumbnailSlideHtml(imageUrl, index, variant) {
    return (
      '<div class="keen-slider__slide product-gallery__thumb-slide">' +
      buildThumbnailHtml(imageUrl, index, variant) +
      '</div>'
    );
  }

  function updateActiveThumb(index) {
    document.querySelectorAll('.product-gallery .image-thumbnail').forEach(function (thumb) {
      var thumbIndex = parseInt(thumb.dataset.index, 10);
      var isActive = thumbIndex === index;
      thumb.classList.toggle('active', isActive);
      thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function syncThumbSliders(index) {
    if (thumbDesktopInstance) {
      var desktopIdx = Math.min(index, thumbDesktopInstance.track.details.maxIdx);
      thumbDesktopInstance.moveToIdx(desktopIdx);
    }
    if (thumbMobileInstance) {
      var mobileIdx = Math.min(index, thumbMobileInstance.track.details.maxIdx);
      thumbMobileInstance.moveToIdx(mobileIdx);
    }
    updateActiveThumb(index);
  }

  function bindThumbClicks(mainSlider) {
    document.querySelectorAll('.product-gallery .image-thumbnail').forEach(function (thumbnail) {
      if (thumbnail.dataset.galleryBound === 'true') return;
      thumbnail.dataset.galleryBound = 'true';
      thumbnail.addEventListener('click', function () {
        var targetIndex = parseInt(this.dataset.index, 10);
        if (!Number.isNaN(targetIndex)) mainSlider.moveToIdx(targetIndex);
      });
    });
  }

  function updateMainNavState(mainSlider) {
    var nav = document.querySelector('[data-product-gallery-nav]');
    if (!nav || !mainSlider) return;

    var details = mainSlider.track.details;
    var prevBtn = nav.querySelector('[data-gallery-prev]');
    var nextBtn = nav.querySelector('[data-gallery-next]');

    if (prevBtn) prevBtn.disabled = details.rel <= 0;
    if (nextBtn) nextBtn.disabled = details.rel >= details.maxIdx;
  }

  function bindMainNav(mainSlider) {
    var nav = document.querySelector('[data-product-gallery-nav]');
    if (!nav || nav.dataset.galleryNavBound === 'true') return;
    nav.dataset.galleryNavBound = 'true';

    var prevBtn = nav.querySelector('[data-gallery-prev]');
    var nextBtn = nav.querySelector('[data-gallery-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        mainSlider.prev();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        mainSlider.next();
      });
    }

    updateMainNavState(mainSlider);
  }

  function bindGalleryKeyboard() {
    var root = getGalleryRoot();
    if (!root || root.dataset.galleryKeyboardBound === 'true') return;
    root.dataset.galleryKeyboardBound = 'true';

    document.addEventListener('keydown', function (event) {
      if (!mainSliderInstance || !root.isConnected) return;
      if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        mainSliderInstance.prev();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        mainSliderInstance.next();
      }
    });
  }

  function initThumbDesktop() {
    var el = document.getElementById('thumb-slider-desktop');
    if (!el || typeof KeenSlider === 'undefined') return null;

    var slideCount = el.querySelectorAll('.keen-slider__slide').length;
    if (slideCount === 0) return null;

    var perView = Math.min(DESKTOP_THUMB_PER_VIEW, slideCount);
    var railHeight =
      perView * DESKTOP_THUMB_HEIGHT + Math.max(0, perView - 1) * DESKTOP_THUMB_SPACING;
    el.style.height = railHeight + 'px';
    el.style.maxHeight = railHeight + 'px';

    return new KeenSlider(el, {
      vertical: true,
      drag: slideCount > perView,
      rubberband: false,
      slides: { perView: perView, spacing: DESKTOP_THUMB_SPACING },
      breakpoints: {
        '(max-width: 1023px)': { disabled: true },
      },
    });
  }

  function initThumbMobile() {
    var el = document.getElementById('thumb-slider-mobile');
    if (!el || typeof KeenSlider === 'undefined') return null;

    var slideCount = el.querySelectorAll('.keen-slider__slide').length;
    if (slideCount === 0) return null;

    return new KeenSlider(el, {
      drag: slideCount > 1,
      rubberband: false,
      slides: { perView: 'auto', spacing: 8, origin: 'auto' },
      breakpoints: {
        '(min-width: 1024px)': { disabled: true },
      },
    });
  }

  function initThumbSliders() {
    thumbDesktopInstance = initThumbDesktop();
    thumbMobileInstance = initThumbMobile();
  }

  function initMainSlider() {
    var el = document.querySelector('#main-slider');
    if (!el || typeof KeenSlider === 'undefined') return null;

    destroySliders();

    var slideCount = el.querySelectorAll('.keen-slider__slide').length;
    if (slideCount === 0) return null;

    mainSliderInstance = new KeenSlider(
      el,
      {
        loop: false,
        slides: { perView: 1, spacing: 0 },
        created: function (slider) {
          initThumbSliders();
          bindThumbClicks(slider);
          bindMainNav(slider);
          bindGalleryKeyboard();
          syncThumbSliders(slider.track.details.rel);
          updateMainNavState(slider);
        },
        slideChanged: function (slider) {
          syncThumbSliders(slider.track.details.rel);
          updateMainNavState(slider);
        },
      },
      [window.wheelControls]
    );

    return mainSliderInstance;
  }

  function rebuildThumbnailSlider(elementId, images, variant) {
    var el = document.getElementById(elementId);
    if (!el) return;
    el.innerHTML = '';
    images.forEach(function (imageUrl, index) {
      el.insertAdjacentHTML('beforeend', buildThumbnailSlideHtml(imageUrl, index, variant));
    });
  }

  function rebuildGallery(images, options) {
    var mainSlider = document.querySelector('#main-slider');
    if (!mainSlider || !images || !images.length) return;

    options = options || {};
    var nextKey = normalizeVisualKey(images[0]);
    var visualChanged = Boolean(nextKey && lastGalleryVisualKey && nextKey !== lastGalleryVisualKey);
    if (options.animate && visualChanged) startVariantLoading();

    destroySliders();

    mainSlider.querySelectorAll('.keen-slider__slide').forEach(function (slide) {
      slide.remove();
    });

    images.forEach(function (imageUrl, index) {
      var slide = document.createElement('div');
      slide.className = 'keen-slider__slide';
      slide.dataset.mediaId = imageUrl;
      slide.innerHTML = buildMainSlideHtml(imageUrl, index === 0);
      mainSlider.appendChild(slide);
    });

    rebuildThumbnailSlider('thumb-slider-desktop', images, 'desktop');
    rebuildThumbnailSlider('thumb-slider-mobile', images, 'mobile');

    var thumbsWrapper = document.querySelector('.product-gallery__thumbs-mobile-wrapper');
    if (thumbsWrapper) thumbsWrapper.hidden = images.length <= 1;

    initMainSlider();
    finishGalleryLoading(mainSlider.querySelector('.main-image'));
    maybeShowWatchHint(images);
  }

  function getGalleryImagesFromLabel(label) {
    if (!label) return null;

    var source = label.querySelector('[data-images]');
    if (!source && label.hasAttribute('data-images')) {
      source = label;
    }
    if (!source) return null;

    try {
      var images = JSON.parse(source.getAttribute('data-images'));
      return images && images.length ? images : null;
    } catch (err) {
      return null;
    }
  }

  function syncGalleryFromVariantPicker(changedInput, options) {
    var images = null;

    if (changedInput && changedInput.id) {
      images = getGalleryImagesFromLabel(document.querySelector('label[for="' + changedInput.id + '"]'));
    }

    if (!images) {
      var variantSelects = document.querySelector('variant-selects');
      var productInfo = document.querySelector('main > section > product-info');
      var variantIdInput = productInfo && productInfo.querySelector('input[name="id"]');
      var variantId = variantIdInput && variantIdInput.value;

      if (variantSelects && variantId) {
        variantSelects.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
          if (String(input.getAttribute('data-id-variant')) === String(variantId)) {
            var matchedImages = getGalleryImagesFromLabel(document.querySelector('label[for="' + input.id + '"]'));
            if (matchedImages) images = matchedImages;
          }
        });
      }
    }

    if (!images) {
      var variantSelectsFallback = document.querySelector('variant-selects');
      if (variantSelectsFallback) {
        variantSelectsFallback.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
          var fallbackImages = getGalleryImagesFromLabel(document.querySelector('label[for="' + input.id + '"]'));
          if (fallbackImages) images = fallbackImages;
        });
      }
    }

    if (images) rebuildGallery(images, options);
  }

  function setupVariantChange() {
    var productInfo = document.querySelector('main > section > product-info');
    if (!productInfo) return;

    if (productInfo.dataset.galleryChangeBound === 'true') return;
    productInfo.dataset.galleryChangeBound = 'true';

    productInfo.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;
      pendingUserVariantChange = true;
      syncGalleryFromVariantPicker(e.target, { animate: true });
    });

    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(function () {
          syncGalleryFromVariantPicker(null, { animate: true });
        }, 50);
      });
    }
  }

  function dispatchDefaultVariantChange() {
    setTimeout(function () {
      document.querySelectorAll('variant-selects fieldset').forEach(function (fieldset) {
        var inputs = fieldset.querySelectorAll('input[type="radio"]');
        if (!Array.from(inputs).some(function (input) {
          return input.checked;
        }) && typeof inputs[0] !== 'undefined') {
          inputs[0].checked = true;
          inputs[0].dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }, 400);
  }

  window.openPopup = function (imageElement) {
    var popup = document.getElementById('imagePopup');
    var popupImage = document.getElementById('popupImage');
    if (!popup || !popupImage) return;
    popupImage.src = imageElement.getAttribute('data-large-src') || imageElement.src;
    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  };

  window.closePopup = function () {
    var popup = document.getElementById('imagePopup');
    if (!popup) return;
    popup.style.display = 'none';
    document.body.style.overflow = '';
  };

  window.initProductGallery = function () {
    if (!document.querySelector('#main-slider')) return;

    setupVariantChange();
    setupWatchHint();
    maybeShowWatchHintAfterVersionLanding();

    var root = getGalleryRoot();
    var raw = root && root.getAttribute('data-initial-gallery-images');
    if (raw) {
      try {
        var initialImages = JSON.parse(raw);
        if (initialImages && initialImages.length) {
          rebuildGallery(initialImages);
          dispatchDefaultVariantChange();
          return;
        }
      } catch (err) {
        /* ignore */
      }
    }

    initMainSlider();
    dispatchDefaultVariantChange();
  };

  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('#main-slider')) {
      window.initProductGallery();
    }
  });
})();
